module.exports = __webpack_public_path__ + "static/media/enterprises-icon-4.abcf7196.svg";